import { render } from "./RouwdrukwerkView.vue?vue&type=template&id=2afe379c"
import script from "./RouwdrukwerkView.vue?vue&type=script&lang=js"
export * from "./RouwdrukwerkView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__